import type { App } from "vue"

import TqButton from "./Button/src/main.vue"
import TqCensorDialog from "./CensorDialog/src/main.vue"
import TqCustomColumns from "./CustomColumns/src/main.vue"
import TqDepartmentSelectorSaas from "./DepartmentSelectorSaas/src/main.vue"
import TqDialog from "./Dialog/src/main.vue"
import TqExpandCondition from "./ExpandCondition/src/main.vue"
import TqIcon from "./Icon/src/main.vue"
// @ts-ignore
import TqListView from "./ListView/src/main.vue"
import TqPageAsideMenu from "./PageAsideMenu/src/main.vue"
import TqPageAsideMenuItem from "./PageAsideMenuItem/src/main.vue"
import TqPageHeader from "./PageHeader/src/main.vue"
import TqPageLayout from "./PageLayout/src/main.vue"
import TqPageTabs from "./PageTabs/src/main.vue"
import TqPagination from "./Pagination/src/main.vue"
import TqPersonSelectorSaas from "./PersonSelectorSaas/src/main.vue"
import TqSelectTree from "./SelectTree/src/main.vue"
import TqSensitive from "./Sensitive/src/main.vue"
import ErrorView from "./ErrorView/src/main.vue"
import HeaderBack from "./HeaderBack/src/main.vue"
import Iframe from "./Iframe/src/main.vue"
import Form from "./Form/src/main.vue"
import Row from "./Row/src/main.vue"
import Col from "./Col/src/main.vue"
import AsideMenu from "./AsideMenu/src/main.vue"
import TextEllipsis from "./TextEllipsis/src/main.vue"
import TqSupplierSelector from "./SupplierSelector/src/main.vue"
import TqTable from "./Table/src/main.vue"
import TqTableColumn from "./TableColumn/src/main.vue"
import TqPersonSelector from "./TqPersonSelector/src/index.vue"
import TqSearchInput from "./TqSearchInput/src/index.vue"
import TqVersionDepartmentSelector from "./TqVersionDepartmentSelector/src/index.vue"
import TqCustomTooltip from "./custom-tooltip/src/main.vue"
import TqDialogForm from "./DialogForm/src/main.vue"
import CapsuleTabs from "./CapsuleTabs/src/main.vue"
import TqProjectCustomerSelector from "./ProjectCustomerSelector/src/main.vue"

export const allBasicComponents:any = {
    TqButton,
    Iframe,
    HeaderBack,
    Row,
    AsideMenu,
    Col,
    Form,
    TextEllipsis,
    TqCensorDialog,
    TqCustomColumns,
    TqDepartmentSelectorSaas,
    TqDialog,
    TqExpandCondition,
    TqIcon,
    TqListView,
    TqPageAsideMenu,
    TqPageAsideMenuItem,
    TqPageHeader,
    TqPageLayout,
    TqPageTabs,
    TqPagination,
    TqPersonSelectorSaas,
    TqSelectTree,
    TqSensitive,
    ErrorView,
    TqSupplierSelector,
    TqTable,
    TqTableColumn,
    TqPersonSelector,
    TqSearchInput,
    TqVersionDepartmentSelector,
    TqCustomTooltip,
    TqDialogForm,
    CapsuleTabs,
    TqProjectCustomerSelector
}
const install = (app: App) => {
    Object.keys(allBasicComponents).forEach((componentName:any) => {
        app.component(componentName, allBasicComponents[componentName])
    })
}


export default {
    install
}